import { MAIN_BLUE } from '../color';
import { RESET_DATE_RANGE, SET_DATE_RANGE } from '../constants';

const initial = {
  startDate: new Date().toISOString(),
  endDate: new Date().toISOString(),
  key: 'selection',
  color: MAIN_BLUE,
  edit: false,
};

export default (state = initial, event) => {
  switch (event.type) {
    case SET_DATE_RANGE:
      return {
        ...state,
        startDate: event.data.startDate,
        endDate: event.data.endDate,
        key: event.data.key,
        color: MAIN_BLUE,
      };

    case RESET_DATE_RANGE:
      return {
        ...state,
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        key: 'selection',
        color: MAIN_BLUE,
      };
    default:
      return state;
  }
};
